import React, { useState, useEffect, useRef } from "react";
import { TranslateIcon } from "Website/assets/images";

const SelectLanguage = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = (e) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    };

    // Close when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelect = (lang) => {
        props.handleSetLanguage(lang);
        setIsOpen(false);
    };

    const getLanguageLabel = (lang) => {
        if (lang === "en") return "English";
        if (lang === "fr") return "French";
        return "English";
    };

    return (
        <div ref={dropdownRef} className="custom-language-dropdown">
            <button
                onClick={toggleDropdown}
                className={`language-dropdown-trigger ${isOpen ? "open" : ""}`}
            >
                {/* Translate Icon */}
                <TranslateIcon className="translate-icon" />
                
                {/* Language Text */}
                <span>{getLanguageLabel(props.selectedLang)}</span>

                {/* Arrow Icon */}
                <svg 
                    width="12" 
                    height="8" 
                    viewBox="0 0 12 8" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                    className={`arrow-icon ${isOpen ? "open" : ""}`}
                >
                    <path 
                        d="M1.5 2L6 6.5L10.5 2" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    />
                </svg>
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="language-dropdown-menu">
                    {[
                        { code: "en", name: "English" },
                        { code: "fr", name: "French" }
                    ].map((lang) => {
                        const isActive = props.selectedLang === lang.code;
                        return (
                            <button
                                key={lang.code}
                                onClick={() => handleSelect(lang.code)}
                                className="language-dropdown-item"
                            >
                                <span>{lang.name}</span>
                                {isActive && (
                                    <svg 
                                        width="14" 
                                        height="10" 
                                        viewBox="0 0 14 10" 
                                        fill="none" 
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="checkmark-icon"
                                    >
                                        <path 
                                            d="M1.5 5L5 8.5L12.5 1" 
                                            strokeWidth="2.5" 
                                            strokeLinecap="round" 
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                )}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default SelectLanguage;